import React, { useMemo } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles';
import './styles.css';
import { textStyles} from '../../../shared/theme/fonts-ppv'
import { authStateSelector, AUTH_STATE_KEY } from '../../auth-reducer';
import {
  RBHButton,
  RBHBox,
  RBHText,
  RBHImage,
  RBHTextInput,
  RBHTextPasswordInput,
} from '../../../shared/components';
import { Dropdown, Form, Menu } from 'antd';
import { Checkbox } from 'antd';
import { CommonValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { authSagas } from '../../auth-saga';
import { AUTH_LOCAL_STORAGE_KEY, AUTH_REQUEST_ID_LIST, COGNITO_CHALLENGE } from '../../auth-constant';
import commonStyle from '../../../shared/theme/common-style';
import { Colors, Fonts, Images } from '../../../shared/theme';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../shared/components/rbh-text/styles';
import { Store } from 'antd/lib/form/interface';
import { AuthService } from '../../auth-services';
import { Base64 } from 'js-base64';
import { LoginData } from '../../auth-type';
import { registerLocalStorage } from '../../../shared/helpers/utility';
import UserOutlined from '@ant-design/icons/lib/icons/UserOutlined';
import { DownOutlined, LockOutlined } from '@ant-design/icons';
import { getLanguageOptions, Locale } from '../../../language';
import stylesText from '../../../shared/components/rbh-text/styles';
import { GENERAL_STATE_KEY, generalStateSelector } from '../../../redux/general/general-reducer';
import { generalCreators } from '../../../redux/general/general-action';

export const SignInScreen: React.FC<Props> = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const [redirectToReferrer, setRedirectToReferrer] = React.useState({
    status: false,
    pathname: '',
  });
  const [formInvalid, setFormInvalid] = React.useState(true);
  const authStatus = useSelector(authStateSelector(AUTH_STATE_KEY.STATUS));
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const currentLocale = useSelector(generalStateSelector(GENERAL_STATE_KEY.LOCALE)) as Locale;

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    switch (authStatus) {
      case COGNITO_CHALLENGE.LOGIN_SUCCESS:
        setRedirectToReferrer({ status: true, pathname: '/main' });
        break;
      case COGNITO_CHALLENGE.NEW_PASSWORD_REQUIRED:
        history.push('/resetpassword');
        break;
    }
  }, [authStatus]);

  const onFinish = (values: Store) => {
    const userData: LoginData = {
      username: String(values.email).trim().toLowerCase(),
      password: Base64.encode(values.password),
    };
    registerLocalStorage(AUTH_LOCAL_STORAGE_KEY.IS_REMEMBER, values.remember);
    registerLocalStorage(AUTH_LOCAL_STORAGE_KEY.EMAIL, userData.username);
    dispatch(
      httpCreators.request({
        service: AuthService.login,
        serviceParams: userData,
        id: AUTH_REQUEST_ID_LIST.LOGIN,
        sagaHandler: authSagas.loginHandler,
      })
    );
  };

  const checkFormInvalid = () => {
    const values = form.getFieldsValue();
    const emailField = values.email || '';
    const passwordField = values.password || '';

    if (emailField.length && passwordField.length) {
      const errors = form.getFieldsError();
      setFormInvalid(false);
      for (const field of errors) {
        if (field.errors.length > 0) {
          setFormInvalid(true);
          break;
        }
      }
    } else {
      setFormInvalid(true);
    }
  };

  const translationMenu = useMemo(() => {
      return (
        <Menu >
          {getLanguageOptions().map((option) => {
            return (
              <Menu.Item key={option.value}>
                <a id={`${option.value}-translation-menu`} onClick={() => onChangeLanguage(option.value)}>
                  <RBHText
                    id={`${option.value}-translation-menu-text`}
                    data-testid={`${option.value}-translation-menu-text`}
                    style={{ ...textStyles.body2 }}
                  >
                    {option.label}
                  </RBHText>
                </a>
              </Menu.Item>
            );
          })}
        </Menu>
      );
  },[getLanguageOptions()])

  function onChangeLanguage(locale: Locale) {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.LOCALE, locale));
  }

  if (redirectToReferrer.status) {
    const { from } = { from: { pathname: redirectToReferrer.pathname } };
    return <Redirect to={from} />;
  }
  return (
   <RBHBox className="signin-container">
      <RBHBox
        className="signin-background-section"
        style={{
          backgroundImage: `url(${Images.loginBgImage2})`,
        }}
      />
      <RBHBox className="signin-form-section">
        {/* Header */}
        <RBHBox className="signin-header">
          <RBHBox style={styles.iconBox} className="signin-icon-box">
            <RBHImage style={styles.iconImage} src={Images.logoRbhShop} />
          </RBHBox>
          <RBHBox>
              <Dropdown overlay={translationMenu} trigger={['click']}>
                <RBHBox style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                  <RBHText style={{ ...textStyles.h4 }}>{currentLocale.toUpperCase()}</RBHText>
                  <DownOutlined translate={'no'}/>
                </RBHBox>
              </Dropdown>
          </RBHBox>
        </RBHBox>
        {/* Content */}
        <RBHBox style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '24px',
          width: '100%',
          maxWidth:'500px',
          alignSelf: 'center',
        }}>
          <RBHText style={textStyles.h2}>
            <FormattedMessage id={'main.login.title'} />
          </RBHText>
            <Form
              form={form}
              name='normal_login'
              style={{...styleText.formText, width: '100%'}}
              onFieldsChange={checkFormInvalid}
              onFinish={onFinish}
              layout="vertical"
            >
              <Form.Item
                label={
                  <RBHBox style={{ ...textStyles.body2, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <UserOutlined translate={'no'} style={{ color: Colors.gray }} className="site-form-item-icon" />
                    <FormattedMessage id={'main.login.email.title'} />
                  </RBHBox>
                }
                name='email'
                colon={false}
                rules={[
                  {
                    validator: (_, value) => {
                      const trimmedValue = value ? value.trim() : value;

                      if (trimmedValue && !CommonValidator.Email.regexPattern.test(trimmedValue)) {
                        return Promise.reject(<FormattedMessage id={'main.login.email.format.valid'} />);
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
                validateTrigger={['onChange', 'onBlur']}
              >
                <RBHTextInput
                  id={'id-email'}
                  style={{ width: '100%', ...textStyles.body2 }}
                  autoComplete='off'
                  placeholder={'main.login.email.placeholder'}
                />
              </Form.Item>

              <Form.Item
               label={
                  <RBHBox style={{ ...textStyles.body2, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <LockOutlined translate={'no'} style={{ color: Colors.gray }} className="site-form-item-icon" />
                    <FormattedMessage id={'main.login.password.title'} />
                  </RBHBox>
                }
                name='password'
                colon={false}
              >
                <RBHTextPasswordInput
                  id={'id-password'}
                  style={{ width: '100%', ...textStyles.body2 }}
                  type='password'
                  placeholder={'main.login.password.placeholder'}
                />
              </Form.Item>

              <RBHBox style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
                <Form.Item 
                  name='remember' 
                  valuePropName='checked' 
                  style={{ margin: 0 }}
                >
                  <Checkbox id={'id-remember-me'} style={{ margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <RBHText style={{...textStyles.body2, display: 'inline'}}>
                      <FormattedMessage id={'main.login.rememberme'} />
                    </RBHText>
                  </Checkbox>
                </Form.Item>
                <RBHText
                  style={{
                    ...textStyles.subtitle2, 
                    margin: 0, 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    color: Colors.violet800
                  }}
                  onClick={() => {
                    history.push('/forgotpassword');
                  }}
                >
                  <FormattedMessage id={'main.login.forgotpassword'} />
                </RBHText>
              </RBHBox>

              <RBHButton
                id={'id-submit'}
                style={{...styles.buttonBox, borderRadius: '8px'}}
                disabled={formInvalid}
                type='primary'
                htmlType='submit'
              >
                <FormattedMessage id={'main.login.submit'} />
              </RBHButton>
            </Form>
        </RBHBox>
        {/* Footer */}
        <RBHBox style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px', textAlign: 'center' }}>
          <RBHText style={{...textStyles.body2, color: Colors.grey400}}>
            <FormattedMessage id={'main.login.lineoa'} />
            <RBHText style={{...textStyles.h5, color: Colors.violet800}}>@robinhoodshop</RBHText>
          </RBHText>
        </RBHBox>
    </RBHBox>
  </RBHBox>
   
  );
};

type Props = {};
